<template>
  <page-list
    :list="list"
    :columns="templateListColumns || columns"
    :group-actions="groupActions"
    :single-actions="singleActions"
    :showSearchbox="showSearchbox"
    :export-data-options="exportDataOptions"
    :show-group-actions="showGroupActions"
    :show-single-actions="!isTemplate"
    :show-page="!isTemplate" />
</template>

<script>
import * as R from 'ramda'
import ListMixin from '@/mixins/list'
import WindowsMixin from '@/mixins/windows'
import ResTemplateListMixin from '@/mixins/resTemplateList'
import GlobalSearchMixin from '@/mixins/globalSearch'
import ColumnsMixin from '../mixins/columns'
import SingleActionsMixin from '../mixins/singleActions'
import { getInternalResourceFilters } from '../../utils'

export default {
  name: 'ApprovedDoneList',
  mixins: [WindowsMixin, ListMixin, GlobalSearchMixin, ColumnsMixin, SingleActionsMixin, ResTemplateListMixin],
  props: {
    id: String,
    listId: String,
    getParams: {
      type: Object,
    },
  },
  data () {
    return {
      list: this.$list.createList(this, {
        id: this.listId || this.id,
        resource: 'historic-task-instances',
        apiVersion: 'v1',
        getParams: this.getParam,
        sortKeys: ['create_time'],
        filterOptions: {
          process_instance_id: {
            label: this.$t('common_350'),
          },
          ...getInternalResourceFilters(),
        },
        genParamsCb: (params) => {
          return {
            ...params,
            details: false,
          }
        },
        isTemplate: this.isTemplate,
        templateLimit: this.templateLimit,
        hiddenColumns: ['alert_record_count', 'alert_info'],
      }),
      groupActions: [],
    }
  },
  computed: {
    exportDataOptions () {
      return {
        downloadType: 'local',
        items: this.columns,
      }
    },
  },
  created () {
    this.initSidePageTab('approval-done-detail')
    this.list.fetchData()
  },
  methods: {
    getParam () {
      const ret = {
        ...(R.is(Function, this.getParams) ? this.getParams() : this.getParams),
        ...this.getParams,
        user_id: this.userInfo.id,
        delete_reason: 'completed',
        process_definition_key_exclude: 'customer-service',
      }
      ret.filter = ret.filter ? (Array.isArray(ret.filter) ? ret.filter : [ret.filter]) : []
      if (ret.project_id) {
        ret.filter.push(`variables->project.equals(${ret.project_id})`)
        delete ret.project_id
      }
      if (ret.domain_id) {
        ret.filter.push(`variables->project_domain.equals(${ret.domain_id})`)
        delete ret.domain_id
      }
      return ret
    },
    handleOpenSidepage (row) {
      this.sidePageTriggerHandle(this, 'ApprovedDoneSidePage', {
        id: row.id,
        resource: 'historic-task-instances',
        apiVersion: 'v1',
        getParams: this.getParam,
      }, {
        list: this.list,
      })
    },
  },
}
</script>
